import React, { useMemo, useState } from "react";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Guid } from "@/Common/Models/Guid";
import useDeleteFlowsheetTemplate from "@/Flowsheets/Hooks/useDeleteFlowsheetTemplate";
import { useFlowsheetTemplates } from "@/Flowsheets/Hooks/useFlowsheetTemplates";
import { useGetFlowsheetName } from "@/Flowsheets/Hooks/useGetFlowsheetName";
import SettingsTabRow from "@/Settings/Components/SettingsTabRow";
import DeletableItemsList, { IDeletableItem } from "./DeletableItemsList";
import DeleteFlowsheetTemplatePopup from "./DeleteFlowsheetTemplatePopup";

function FlowsheetTemplateSettingsSectionController(): React.ReactElement {
    const [selectedTemplate, setSelectedTemplate] = useState<IDeletableItem<Guid> | null>(null);
    const { data, refetch } = useFlowsheetTemplates();
    const { mutate: deleteFlowsheetTemplateCommand } = useDeleteFlowsheetTemplate({
        onSuccess: refetch
    });
    const { getText } = useTranslation();
    const { getName } = useGetFlowsheetName();

    function handleOnDeleteClick(template: IDeletableItem<Guid>): void {
        setSelectedTemplate(template);
    }

    function closeModal(): void {
        setSelectedTemplate(null);
    }

    function handleDelete(): void {
        if (selectedTemplate) {
            deleteFlowsheetTemplateCommand(selectedTemplate.Id);
        }

        closeModal();
    }

    const deleteableItems = useMemo(() => data?.map(template => ({
        Id: template.Id,
        Name: getName(template)
    })) ?? [], [data, getName]);

    return (
        <>
            <SettingsTabRow title={getText("Flowsheets_MyFlowsheets")}>
                <DeletableItemsList
                    deleteableItems={deleteableItems}
                    onDeleteClick={handleOnDeleteClick}
                />
            </SettingsTabRow>

            {selectedTemplate && (
                <DeleteFlowsheetTemplatePopup onConfirm={handleDelete} onCancel={closeModal} />
            )}
        </>
    );
}

export default FlowsheetTemplateSettingsSectionController;
